<template>
	<div>
		<b-form class=" form landing-form">
			<router-link to="/" class="modal-logo">
				<img src="../../assets/logo_en.svg" width="129" alt="" />
			</router-link>

			<h3 class="mt-4 mb-3 font-weight-normal">
				{{ 'Sign up for a trial lesson' | translate }}
			</h3>
			<div class="d-flex mobile-column">
				<b-form-group class="form-group-custom  mb-3 mr-2">
					<b-form-input id="email" :placeholder="'Parents name' | translate" :state="!!signError ? false : null"
						v-model="name" type="text" required></b-form-input>
				</b-form-group>
				<b-form-group class="form-group-custom  mb-3 ">
					<b-form-input id="" :placeholder="'Childs age' | translate" :state="!!signError ? false : null" v-model="age"
						type="number" required></b-form-input>
				</b-form-group>
			</div>
			<b-form-invalid-feedback :state="!!signError ? false : null">
				{{ signError | translate }}
			</b-form-invalid-feedback>
			<div :class="signError ? 'phone-error' : ''" class="phone">
				<VuePhoneNumberInput :default-country-code="getDefaultCode()" required :state="!!signError ? false : null"
					show-code-on-list fetch-country v-model="phone" error-color="#f11212" />
			</div>

			<div class="d-flex  mb-3 mobile-column">
				<b-form-group class="form-group-custom mr-2">
					<b-form-input id="country" :placeholder="'Country' | translate" :state="!!signError ? false : null"
						v-model="country" type="text" required></b-form-input>
				</b-form-group>
				<b-form-group class="form-group-custom">
					<b-form-input :placeholder="'City' | translate" :state="!!signError ? false : null" v-model="city" type="text"
						required></b-form-input>
				</b-form-group>
			</div>

			<div class="d-flex align-items-center">
				<button :disabled="loading" @click.prevent="signIn" class="button-custom button-pink mb-2">
					{{ 'Sign up' | translate }}
				</button>
			</div>
		</b-form>
		<b-modal :visible="showModalAddNotification" @cancel="close">
			Дякуємо, за проявлений інтерес до ментальної арифметики. Ваша заявка
			прийнята в роботу. Незабаром Вас набере менеджер.
		</b-modal>
	</div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import ModalAddNotification from '../../components/Dashboard/Modal/AddNotification'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

@Component({
	components: {
		ModalAddNotification,
		VuePhoneNumberInput,
	},
})
export default class RegistrationTrialLes extends Vue {
	name = ''
	age = null
	phone = ''
	country = null
	city = null
	signError = ''
	loading = false
	showModalAddNotification = false
	phoneError = ''

	getDefaultCode() {
		return window.location.origin.includes('pl.indigo') ? 'PL' : 'UA'
	}

	signIn() {
		const input_code = document.querySelector('.country-selector__input')
		const code_value = input_code.value
		if (!this.phone) {
			this.phoneError = 'Field required'
		}
		this.loading = true
		this.signError = ''
		this.phoneError = ''
		this.axios({
			method: 'post',
			url: 'trial_lessons',
			data: {
				parent_name: this.name,
				child_age: this.age,
				phone_number: code_value + this.phone,
				country: this.country,
				city: this.city,
			},
		})
			.then(response => {
				if (response.data) {
					this.showModalAddNotification = true
					this.loading = false
					this.name = ''
					this.age = null
					this.phone = ''
					this.country = null
					this.city = null
				}
			})
			.catch(() => {
				this.loading = false

				this.signError = 'Password or login is not correct'
			})
	}
}
</script>

<style lang="scss">
.landing-form {
	padding: 28px 38px;
	box-shadow: 0px 7.04161px 15.3294px rgba(67, 67, 67, 0.0752215),
		0px 4.92415px 6.3357px rgba(67, 67, 67, 0.0444555),
		0px 2.89319px 3.08708px rgba(67, 67, 67, 0.0185339),
		0px 1.21701px 1.54994px rgba(67, 67, 67, 0.00421641);
	border-radius: 16px;
	max-width: 432px;

	@media (max-width: 778px) {
		.mobile-column {
			//max-width: 320px;
			flex-direction: column !important;
			justify-content: stretch !important;
			align-items: stretch !important;

			fieldset {
				margin-right: 0 !important;
			}
		}
	}

	.country-selector__label {
		display: none !important;
	}

	.country-selector__input {
		padding-top: 0;
		height: 55px;
		border: 1px solid #c7c9e9;
		border-right: none;
		position: relative;
		border-top-left-radius: 16px !important;
		border-bottom-left-radius: 16px !important;

		&:hover {
			border: 1px solid #c7c9e9 !important;
			border-right: none !important;
		}
	}

	.country-selector__toggle {
		top: 50%;
		transform: translateY(-5px);
		right: 18px;
	}

	.input-tel__input {
		height: 55px;
		border: 1px solid #c7c9e9;
		border-left: none;
		border-top-right-radius: 16px !important;
		border-bottom-right-radius: 16px !important;
		outline: none !important;

		&:hover,
		&:active,
		&:focus {
			border: 1px solid #c7c9e9 !important;
			border-left: none !important;
			outline: none !important;
			caret-color: #c7c9e9 !important;
		}
	}

	.input-tel.input-phone-number.has-value.has-hint {
		.input-tel__input {
			padding-top: 0 !important;
		}

		.input-tel__label {
			display: none;
		}
	}

	.vue-phone-number-input {
		//margin-bottom: 30px;
	}

	.country-selector.input-country-selector.has-value {
		.country-selector__input {
			padding-top: 2px;
		}
	}
}

.phone {
	margin-bottom: 20px;
	padding-bottom: 15px;
	border: 1px solid transparent;
}

.phone-error {
	border: 1px solid red;
	//margin-bottom: 30px;
	position: relative;
	border-radius: 16px;
	z-index: 11;

	&:after {
		content: '';
		padding-right: calc(1.5em + 0.75rem);
		background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
		background-repeat: no-repeat;
		background-position: right calc(0.375em + 0.1875rem) center;
		background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 1;
	}
}
</style>
